import { render, staticRenderFns } from "./getstartForm.vue?vue&type=template&id=af43da12&scoped=true&"
import script from "./getstartForm.vue?vue&type=script&lang=js&"
export * from "./getstartForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af43da12",
  null
  
)

export default component.exports